<template>
  <div class="relative">
    <div class="overlay-disable-setting" v-if="isDisableEditPresentation"></div>
    <aha-checkbox
      id="settings-check-audience-admission"
      @change="handleCheckBoxAudienceAdmission"
      v-model="presentation.audienceAdmission.isAudienceAdmission"
      class="mb-3"
    >
      <span>
        Require participants to enter information
        <AhaSvg
          class="mb-1 ml-1 text-base-70"
          name="question"
          v-tooltip="audienceAdmissionTooltip"
        />
      </span>
    </aha-checkbox>
    <p class="text-xs">
      Participants' info is collected in the Excel file containing your presentation
      report. Please go to <aha-link
        @click="showResultsMenu"
        type="primary"
        variant="primary"
      >
        <span class="text-xs font-bold">Results</span>
      </aha-link> to download the file.
    </p>
    <div class="mt-3 form-group" v-if="presentation.audienceAdmission.isAudienceAdmission">
      <label class="label-option" for="audience-admission-heading">
        Heading
      </label>
      <aha-input
        :maxLength="150"
        placeholder="Your welcome line…"
        class="mt-2 mb-4"
        id="audience-admission-heading"
        @input="handleOnInput"
        v-model="presentation.audienceAdmission.heading"
      />
      <AdditionalFieldsForm
        @updateAdditionalFields="updateAdditionalFields"
        :limitFields="3"
        type="audienceAdmission"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AdditionalFieldsForm from '@/components-v2/presentation-editor/side-right/AdditionalFieldsForm.vue'

export default {
  components: {
    AdditionalFieldsForm,
  },
  props: {
    handleCheckBoxAudienceAdmission: {
      type: Function,
      default: () => {},
    },
    handleOnInput: {
      type: Function,
      default: () => {},
    },
    updateAdditionalFields: {
      type: Function,
      default: () => {},
    },
    showResultsMenu: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      audienceAdmissionTooltip: 'Show an entry form for the participants to fill in upon joining',
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
  },
}
</script>

<style lang="scss" scoped>
.overlay-disable-setting {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full z-20;
}
</style>
